/*
 * @Description:
 * @Author: 赵大壮
 * @Date: 2021-12-06 17:18:37
 * @LastEditTime: 2021-12-06 17:36:29
 * @LastEditors: 赵大壮
 */
import { Component, Vue, Inject } from "vue-property-decorator";
import DZModelManager from "@/views/系统管理/model/DZModelManager";
import DZServiceManager from "@/views/系统管理/service/DZServiceManager";
import nyMessageToast from "@/utils/NYMessageToast";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    s_manager = new DZServiceManager();

    created() {
        this.action_page_role();
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    beforeDestroy() {

    }

    handle_add_role(){
        this.$router.push({ path: '/system/roleInfo'})
    }
    handle_edit_role(row){
        this.$router.push({
            path:'/system/roleInfo' ,
            query:{
                id:row.id,
                name:row.name,
                status:row.status,
                menusList:row.menus
            }
        })
    }

    handle_del_role(id){
        if(id == 0){
            nyMessageToast.error('不能删除"超级管理员"角色');
            return;
        }
        this.s_manager.net_del_role(id,this.action_page_role)
    }

    action_page_role(){
        this.s_manager.net_page_role()
    }

    handleDbClick(row){
        if(row.id){
            this.handle_edit_role(row)
        }
    }
}
